import PropTypes from 'prop-types'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import SalesCodeForm from './SalesCodeForm'

const CreateUpdateSalesCode = (props) => {
  return (
    <Modal
      onClose={() => {
        props.setShowModal(false)
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        Update Existing Sales Codes
      </ModalHeader>
      <ModalBody>
        <SalesCodeForm
          onSave={() => {
            props.setShowModal(false)
          }}
        />
      </ModalBody>
    </Modal>
  )
}

CreateUpdateSalesCode.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default CreateUpdateSalesCode
